import {
  SupportTicketStatus,
  type SupportMessageResponse,
  type SupportTicketListResponse,
  type SupportTicketResponse,
} from '~/models/support-ticket';

const BASE = '/api/v1/admin/support/tickets';

export const supportTicketService = {
  async fetchList(
    page: number,
    perPage: number,
    status: SupportTicketStatus = SupportTicketStatus.Open,
  ): Promise<ApiResult<SupportTicketListResponse>> {
    return useMyFetch<SupportTicketListResponse>(BASE, {
      params: { page, per_page: perPage, status },
    });
  },

  async fetchDetail(ticketUid: string): Promise<ApiResult<SupportTicketResponse>> {
    return useMyFetch<SupportTicketResponse>(`${BASE}/${ticketUid}`);
  },

  async create(shopUid: string, title: string, body: string): Promise<ApiResult<SupportTicketResponse>> {
    return useMyFetch<SupportTicketResponse>(BASE, {
      method: 'POST',
      body: { shop_uid: shopUid, title, body },
    });
  },

  async close(ticketUid: string): Promise<ApiResult<EmptyResponse>> {
    return useMyFetch<EmptyResponse>(`${BASE}/${ticketUid}/close`, { method: 'PATCH' });
  },

  async reopen(ticketUid: string): Promise<ApiResult<EmptyResponse>> {
    return useMyFetch<EmptyResponse>(`${BASE}/${ticketUid}/reopen`, { method: 'PATCH' });
  },

  async markSeen(ticketUid: string): Promise<ApiResult<EmptyResponse>> {
    return useMyFetch<EmptyResponse>(`${BASE}/${ticketUid}/seen`, { method: 'PATCH' });
  },

  async sendMessage(
    ticketUid: string,
    body: string,
    imageUrls: string[] = [],
  ): Promise<ApiResult<SupportMessageResponse>> {
    return useMyFetch<SupportMessageResponse>(`${BASE}/${ticketUid}/messages`, {
      method: 'POST',
      body: { body, image_urls: imageUrls.length ? imageUrls : undefined },
    });
  },
};
